export const getLabel = (label: string) => {
  const index = label.lastIndexOf(".");
  return index === -1 ? label : label.substring(index + 1);
};
